import { useAccountSwitcherContext } from '../components/AccountSwitcherProvider';

/**
 * Hook to access session state
 * Returns current session information including authentication status, user, and accounts
 */
export function useSession() {
  const { session, isLoading, error } = useAccountSwitcherContext();

  return {
    ...session,
    isLoading,
    error,
  };
}
